import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import ApiVolumesTrims from '../../api/volumestrims';
import { log as actionsLog } from '../../store/actions';

const { addToLog } = actionsLog;

const AddNewTrimForm = ({ selectedModel, selectedVolume, selectedTrim, trims, notifyTrims }) => {

    let dispatch = useDispatch();

    let [value, setValue] = useState("");
    let [selectedFueltype, setSelectedFueltype] = useState(null);

    let fueltypes = useSelector(store => store.fueltypes.items);

    useEffect(() => {
        if (selectedTrim) {
            setValue(selectedTrim.name);
        }
    }, [selectedTrim]);

    useEffect(() => {
        if (selectedTrim) {
            setSelectedFueltype(fueltypes.find(ft => selectedTrim?.fuelType.id == ft.id));
        } else {
            setSelectedFueltype(fueltypes[0]);
        }
    }, [fueltypes, selectedTrim]);

    const onTrimChange = e => {
        setValue(e.target.value);
    };

    const isDisabledAddButton = () => {
        return ! value.trim() 
        || trims.find(trim => trim.name == value && trim.fuelType?.id == selectedFueltype.id);
    }

    const isDisabledSaveChangesButton = () => {
        return ! selectedTrim 
        || (selectedTrim.name == value && selectedTrim.fuelType?.id == selectedFueltype?.id)
        || trims.find(trim => trim.name == value && trim.fuelType?.id == selectedFueltype.id);
    }

    const selectFueltype = e => {
        const id = e.target.value;
        setSelectedFueltype(fueltypes.find(item => Number(item.id) === Number(id)));
    };

    const add = () => {
        let proceed = window.confirm(`Add new trim: ${value} (fuel type: ${selectedFueltype.name})?`);
        if (proceed) {
            ApiVolumesTrims.addTrim({ 
                idModel: selectedModel.id, 
                idVolume: selectedVolume.id, 
                idFuelType: selectedFueltype.id, 
                name: value
            }).then(resp => {
                dispatch(addToLog(resp));
                notifyTrims();
            });
        }
    }

    const update = () => {
        let proceed = window.confirm(`Update selected trim: ${selectedTrim.name}?`);
        let updateOnlyFuelType = selectedTrim.name == value && selectedTrim.fuelType.id != selectedFueltype.id;
        if (proceed) {
            ApiVolumesTrims.updateTrim({ 
                idModel: selectedModel.id, 
                idVolume: selectedVolume.id, 
                idFuelType: selectedFueltype.id, 
                idTrim: selectedTrim.id,
                oldName: selectedTrim.name,
                newName: value,
                updateOnlyFuelType
            }).then(() => {
                notifyTrims();
            });
        }
    }

    const onSubmit = e => e.preventDefault();

    const btnClasses = (isDisabled) => {
        const common = "border rounded p-2 flex-0 ";
        return common + ( 
            isDisabled ? 
                "border-gray-700 bg-gray-800 cursor-default text-gray-500" : 
                "border-blue-700 bg-blue-800 cursor-pointer hover:bg-blue-700 hover:border-blue-800 text-white"
        );
    }

    return (
        <form onSubmit={e => onSubmit(e)} className="border border-gray-700">
            <div className="flex p-2 flex-col">
                <div className="flex mb-2">
                    <input type="text" className="border bg-gray-700 border-gray-700 rounded p-2 mr-2 w-full text-white" value={value} onChange={e => onTrimChange(e)} />
                    <select value={selectedFueltype?.id} onChange={selectFueltype} className="text-sm px-2 py-1 my-0 bg-gray-800 border border-gray-700 text-white">
                        {fueltypes.map(ft => {
                            return <option value={ft.id} key={ft.id}>{ft.name}</option>
                        })}
                    </select>
                </div>
                
                <div className="flex">
                    
                    <button className={ btnClasses(isDisabledAddButton()) + " ml-auto" } disabled={isDisabledAddButton()} onClick={add}>Add</button>
                    {
                        selectedTrim ? <button className={ btnClasses(isDisabledSaveChangesButton()) + " ml-2" } disabled={isDisabledSaveChangesButton()} onClick={update}>Save changes</button> : <></>
                    }
                </div>
            </div>
        </form>
    );
}

export default AddNewTrimForm;